import { render, staticRenderFns } from "./asdkfss.vue?vue&type=template&id=47de32ed&"
import script from "./asdkfss.vue?vue&type=script&lang=js&"
export * from "./asdkfss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports